import { text, TextDecorations } from "@quickpoint.me/shared";
import { useRecoilValue, useSetRecoilState } from "recoil";
import Underline from "../../icons/underline.svg?react";
import UnderlineActive from "../../icons/underline-active.svg?react";
import { fireWrapSelectionEvent } from "../../lib/editor/events";
import { IsInPortrait } from "../../state/selectors";
import { CanApplyTextFormatting, MousedOverTextHelper } from "../../state/uiAtoms";
import { StyledTextControl } from "../StyledControl";

function UnderlineControl() {
  const setTextHelper = useSetRecoilState(MousedOverTextHelper);
  const isInPortrait = useRecoilValue(IsInPortrait);
  const canFormat = useRecoilValue(CanApplyTextFormatting);

  const handleClick = () => {
    if (!canFormat) return;
    fireWrapSelectionEvent(TextDecorations.underline);
  };

  const mouseOver = () => {
    setTextHelper(canFormat
      ? text.textControls.underline
      : "Select text to apply underline");
  };

  const mouseLeave = () => {
    setTextHelper(undefined);
  };

  return (
    <>
      <StyledTextControl
        $dim={!canFormat}
        onClick={handleClick}
        onMouseOver={mouseOver}
        onMouseLeave={mouseLeave}
        aria-label={text.textControls.underline}
        aria-disabled={!canFormat}
        $isInPortrait={isInPortrait}
        data-testid="underline-control"
      >
        {canFormat ? (
          <UnderlineActive aria-hidden="true" focusable="false" className="format-text-control underline" />
        ) : (
          <Underline aria-hidden="true" focusable="false" className="format-text-control underline" />
        )}
      </StyledTextControl>
    </>
  );
}

export default UnderlineControl;
